import { emailCampaignFeatureGuard, emailCampaignBlockPageGuard } from '@/pages/emailCampaigns/util/routerGuards';

const EmailCampaignsMain = () => import(/* webpackChunkName: "email" */ '@/pages/emailCampaigns/main');
const EmailCampaignAnalytics = () => import(/* webpackChunkName: "email" */ '@/pages/emailCampaigns/campaignAnalytics');
const CreateEmailCampaign = () => import(/* webpackChunkName: "email" */ '@/pages/emailCampaigns/createCampaign');
const EmailCampaignsFeatureBlock = () => import(/* webpackChunkName: "email" */ '@/pages/emailCampaigns/featureBlock');
const Outbox = () => import(/* webpackChunkName: "email" */ '@/pages/outbox');

export default [
  {
    path: 'email/outbox',
    name: 'Email / Outbox',
    component: Outbox,
  },
  {
    path: 'emailcampaigns',
    name: 'Email campaigns',
    component: EmailCampaignsMain,
    beforeEnter: emailCampaignFeatureGuard,
  },
  {
    path: 'emailcampaigns/analytics/:campaign_id?',
    name: 'Email campaigns / Analytics',
    component: EmailCampaignAnalytics,
    beforeEnter: emailCampaignFeatureGuard,
  },
  {
    path: 'emailcampaigns/create/:campaign_id?',
    name: 'Email campaigns / Create',
    component: CreateEmailCampaign,
    beforeEnter: emailCampaignFeatureGuard,
  },
  {
    path: 'emailcampaigns/edit/:campaign_id?',
    name: 'Email campaigns / Edit',
    component: CreateEmailCampaign,
    beforeEnter: emailCampaignFeatureGuard,
  },
  {
    path: 'emailcampaigns/forward/:campaign_id?',
    name: 'Email campaigns / Forward',
    component: CreateEmailCampaign,
    beforeEnter: emailCampaignFeatureGuard,
  },
  {
    path: 'emailcampaigns/create/:campaign_id?',
    name: 'Email campaigns / Create with document',
    component: CreateEmailCampaign,
    beforeEnter: emailCampaignFeatureGuard,
  },
  {
    path: 'emailcampaigns/create/:campaign_id?',
    name: 'Email campaigns / Create with recipient',
    component: CreateEmailCampaign,
    beforeEnter: emailCampaignFeatureGuard,
  },
  {
    path: 'emailcampaigns/setup',
    name: 'Email campaigns / Setup',
    component: EmailCampaignsFeatureBlock,
    beforeEnter: emailCampaignBlockPageGuard,
  },
];
